import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { NewModal } from 'lib/components';
import CustomDateTimePicker from '../custom-time-picker/CustomDateTimePicker';
import { Button } from 'react-covideo-common';

const Content = styled.div`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black[100]};
  margin-top: 24px;
  font-weight: 500;
  line-height: 20px;
`;

const ButtonsWrapper = styled.section`
  display: flex;
  flex-direction: row-reverse;
  margin-top: 32px;
`;

const Description = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral[80]};
  margin-bottom: 16px;
`;

type Props = {
  handleModalClose: () => void;
  handleSubmit: Function;
  setExpiration: (date: Date) => void;
  expiration: Date | null;
  buttonText: string;
};

export const ModalVideoExpiration = ({
  handleModalClose,
  handleSubmit,
  setExpiration,
  expiration,
  buttonText,
}: Props) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  return (
    <NewModal
      headerText={t('Custom Link Expiration')}
      closeModal={handleModalClose}
      style={{
        content: {
          overflow: 'visible',
        },
      }}
    >
      <Content>
        <Description>
          {t("URLs you share won't be accessible after this date and time")}
        </Description>
        {expiration && (
          <CustomDateTimePicker
            setDate={setExpiration}
            date={expiration}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
          />
        )}
        <ButtonsWrapper>
          <Button
            text={buttonText}
            onClick={() => handleSubmit()}
            disabled={!!errorMessage}
          />
        </ButtonsWrapper>
      </Content>
    </NewModal>
  );
};
